// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"bc29ee9e","645":"3c351b6b"}[chunkId] + ".chunk.js";
};